import { CommentRegular } from '@fluentui/react-icons'
import styles from './CommentCellRenderer.module.css'
import { ICellRendererParams } from 'ag-grid-community'

const CommentCellRenderer = (props: ICellRendererParams) => {
  return (
    <span data-testid="CommentCellRenderer">
      {props.value && <CommentRegular className={styles.commentIcon} />}
    </span>
  )
}

export default CommentCellRenderer
